module.exports = __webpack_public_path__ + "img/czdx.b84063cf.png";